import React, { Component,Fragment } from 'react'

export default class Footer extends Component {
    render() {
        const date = new Date();
        return (
            <Fragment>
                <div className="container-fluid py-2" style={{backgroundColor:this.props.mode?"black":"white"}}>

                    <div className="d-flex footer justify-content-center align-items-center  mt-5" style={{backgroundColor:this.props.mode?"black":"white"}}>
                        <h6 className="text-center text-lato" style={{color:this.props.mode?"white":"black"}}>{this.props.language==="en"?"English":"Francais"} | CopyRights@  {date.getFullYear()}</h6>
                    </div>
                </div>
            </Fragment>
        )
    }
}
